// gatsby-browser.js
import React from "react";
import GlobalProvider from "./src/contexts/globalProvider";

export const wrapRootElement = ({ element }) => {
  return <GlobalProvider>{element}</GlobalProvider>;
};
